<template>
  <div>
    <div class="legendColor"
         v-bind:style="{gridTemplateColumns: '0.5fr repeat(' + (2 * (legendMarks.length - 1)) + ', 1fr) 0.5fr'}"
    >
      <span
        v-for="(legend, i) in colorLegendData.slice(1-legendMarks.length)"
        v-bind:key="legend.value+'-base'"
        v-bind:style="{backgroundColor:legend.value}"
        v-bind:class="['box', {first: i === 0, last: (i + 2) === legendMarks.length}]"
      >
         &nbsp;
      </span>
      <span
        v-for="(legend, i) in colorLegendData.slice(1-legendMarks.length)"
        v-bind:key="legend.value+'-tick'"
        v-bind:class="{first: i === 0, last: (i + 2) === legendMarks.length}"
      >
        &nbsp;
      </span>
    </div>
    <div class="legendNames"
         v-bind:style="{gridTemplateColumns: '0.5fr repeat(' + (2 * (legendMarks.length - 1)) + ', 1fr) 0.5fr'}"
    >
          <span
            v-for="legend in legendMarks"
            v-bind:key="legend+'-number'"
          >{{format(legend)}}</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'colerLegend',
    props: [
      "colorLegendData",
      "format",
      "legendMarks",
    ],
  }
</script>
<style scoped>
  .legendColor {
    display: none;
    margin-top: 7px;
    width: 100%;
    grid-template-rows: auto 5px;
    font-size: 0.55em;
  }

  .legendColor span {
    border: black solid 1px;
    border-top: none;
    border-bottom: none;
    grid-column-end: span 2;
  }

  .legendColor .first {
    grid-column-start: 2;
    border-left: black solid 2px;
  }

  .legendColor .box {
    border-bottom: black solid 2px;
  }

  .legendColor .last {
    border-right: black solid 2px;
  }

  .legendNames span {
    grid-column-end: span 2;
  }

  .legendNames span.dash {
    grid-column-end: span 1;
    font-weight: bold;
  }

  .legendNames {
    display: none;
    width: 100%;
    grid-gap: 2px;
    text-align: center;
    font-weight: bold;
    font-size: 0.75em;
  }

  .legendNames span {
    grid-column-end: span 2;
  }

  @media (max-width: 1000px) {

    .legendColor {
      display: grid;
    }

    .legendNames {
      display: grid;
    }

  }
</style>
